import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ExternalLink } from 'lucide-react';
type Review = {
  platform: 'Yelp' | 'Google';
  name: string;
  text: string;
  stars: number;
};
const reviews: Review[] = [{
  platform: 'Yelp',
  name: 'Erika D.',
  text: "Mike is amazing at what he does. He has done my car, my husband's car, my sister's car, my sister-in-law and brother-in law's cars. All of us have been so happy. Mike is incredibly detailed, does an eco-friendly car wash and leaves your car looking so perfectly polished/pristine afterwards. Thank you Mike! We are so happy with your work and will continuously refer you to friends and family. :)",
  stars: 5
}, {
  platform: 'Yelp',
  name: 'Juan R.',
  text: "If you are looking for a good detailing for your car with the convenience of having it done at home, look no further than Mike's Pro Detail! Mike did a great job with our cars. He was responsive, communicated well, arrived on time, and got the job done. I've already used him several times! He's excellent at what he does.",
  stars: 5
}, {
  platform: 'Yelp',
  name: 'Diane B.',
  text: "Mike has washed my cars multiple times. He makes scheduling and communicating easy. He is always friendly and responsive. He's handled tree sap on one car--which was challenging to remove--without extra charge. He is honest (no coins or mints filched) and a pleasure to deal with throughout. Final product is spectacular, without fail. I recommend him without reservation, and I'm a lawyer and fussy about my cars.",
  stars: 5
}, {
  platform: 'Google',
  name: 'Jessica M.',
  text: "I had a great experience with Mike's Pro Detail! I had spilled a smoothie all over my car on the way home one evening - it was in every nook and cranny and was so bad that I couldn't get it out myself. So I had to find a professional to clean it all out before it started to make my car permanently smell of rotting fruit! I luckily found Mike and he was able to fit me in that next morning. He was so nice and helpful and did such a great job doing a deep clean - Thank you again Mike!",
  stars: 5
}, {
  platform: 'Google',
  name: 'David L.',
  text: "This is the second time that I have used Mike's services and I realize now that I should I have called him sooner! He took my black Lexus IS from a dirty, dingy, greyscale embarrassment to a piece of perfection with a showroom shine. Mike arrived early with all necessary equipment and supplies and went straight to work. He is the ultimate professional with great communication and flexibility in his schedule. Can't recommend his services enough! You will be impressed!",
  stars: 5
}, {
  platform: 'Google',
  name: 'Holy B.',
  text: "It was easy to set up an appointment and excellent communication. I had never used a mobile detail service and I was very pleased with Mike's service! My car was filthy from driving to Colorado and back and general lack of care. Mike made it look like new again with a full detail. He was very detailed and asked me to find areas that he could touch up once he was finished. Very professional, nice guy. Definitely would use him again.",
  stars: 5
}];
export function Reviews() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" id="reviews" data-id="element-231">
      <div className="max-w-7xl mx-auto" data-id="element-232">
        <div className="text-center mb-12" data-id="element-233">
          <h2 className="text-5xl md:text-6xl font-black uppercase mb-4" data-id="element-234">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-235">
              5-Star Mobile Detailing Reviews
            </span>
          </h2>
          <div className="h-1 w-24 bg-red-600 mx-auto rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)]" data-id="element-236" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-4" data-id="element-237">
            See why Ventura County and San Fernando Valley trust Mike's Pro
            Detail for professional mobile car detailing
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-238">
          {reviews.map((review, index) => <ReviewCard key={index} review={review} index={index} data-id="element-239" />)}
        </div>

        <div className="text-center mb-12" data-id="element-240">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-900 rounded-full border border-zinc-800 text-sm text-gray-400" data-id="element-241">
            <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-242" />
            <span data-id="element-243">5.0 Average Rating across Google & Yelp</span>
          </div>
        </div>

        {/* Check Us Out CTA */}
        <motion.div initial={{
        y: 30,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="max-w-3xl mx-auto" data-id="element-244">
          <div className="relative bg-gradient-to-br from-zinc-900/80 to-zinc-900/40 backdrop-blur-sm border border-zinc-800 rounded-2xl p-8 md:p-12 overflow-hidden" data-id="element-245">
            {/* Decorative glow */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-600/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-246" />

            <div className="relative z-10 text-center" data-id="element-247">
              <h3 className="text-3xl md:text-4xl font-black uppercase mb-3" data-id="element-248">
                <span className="text-white" data-id="element-249">Check Us Out</span>
              </h3>
              <p className="text-gray-400 text-lg mb-8" data-id="element-250">
                Read more reviews on Google and Yelp to see why our customers
                trust us with their vehicles
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-251">
                {/* Google Review Button */}
                <a href="https://share.google/k4UimfxXqCgBa74jP" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-3 px-6 py-4 bg-white hover:bg-gray-100 text-gray-900 font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-252">
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-253">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-254" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-255" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-256" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-257" />
                  </svg>
                  <span className="uppercase tracking-wider text-sm" data-id="element-258">
                    View Google Reviews
                  </span>
                  <ExternalLink className="w-4 h-4 opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-259" />
                </a>

                {/* Yelp Review Button */}
                <a href="https://www.yelp.com/biz/mikes-pro-detail-agoura" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-3 px-6 py-4 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-260">
                  <img src="https://cdn.magicpatterns.com/uploads/175DFDXm2rpoLToMVtVWMh/yelp_burst.png" alt="Yelp" className="w-6 h-6" data-id="element-261" />
                  <span className="uppercase tracking-wider text-sm" data-id="element-262">
                    View Yelp Reviews
                  </span>
                  <ExternalLink className="w-4 h-4 opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-263" />
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}
function ReviewCard({
  review,
  index
}: {
  review: Review;
  index: number;
}) {
  const isYelp = review.platform === 'Yelp';
  return <motion.div initial={{
    y: 50,
    opacity: 0
  }} whileInView={{
    y: 0,
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="flex flex-col h-full bg-zinc-900/40 backdrop-blur-sm border border-zinc-800 rounded-xl p-6 hover:border-red-900/50 hover:bg-zinc-900/60 transition-all duration-300 group" data-id="element-264">
      {/* Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-265">
        {isYelp ? <img src="https://cdn.magicpatterns.com/uploads/175DFDXm2rpoLToMVtVWMh/yelp_burst.png" alt="Yelp" className="h-6 w-auto" data-id="element-266" /> : <svg className="h-6 w-auto" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-267">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-268" />
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-269" />
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-270" />
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-271" />
          </svg>}
        <div className="flex gap-1" data-id="element-272">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-273" />)}
        </div>
      </div>

      {/* Content */}
      <div className="relative flex-1 mb-6" data-id="element-274">
        <Quote className="absolute -top-2 -left-2 w-8 h-8 text-zinc-800 rotate-180" data-id="element-275" />
        <p className="relative z-10 text-gray-300 leading-relaxed text-sm md:text-base italic pl-4" data-id="element-276">
          "{review.text}"
        </p>
      </div>

      {/* Footer */}
      <div className="flex items-center gap-3 pt-4 border-t border-zinc-800/50" data-id="element-277">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${isYelp ? 'bg-red-900/20 text-red-500' : 'bg-blue-900/20 text-blue-500'}`} data-id="element-278">
          {review.name.charAt(0)}
        </div>
        <div data-id="element-279">
          <p className="font-bold text-white" data-id="element-280">{review.name}</p>
          <p className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-281">
            Verified Customer
          </p>
        </div>
      </div>
    </motion.div>;
}